import { createContext } from 'react'
import type { MixpanelContextValue } from '@/components/mixpanel/types'

const initialState: MixpanelContextValue = {
  track: () => undefined,
  identify: () => undefined,
  identifyCompany: () => undefined,
  register: () => undefined,
  setUserProperties: () => undefined,
  reset: () => undefined,
}

export const MixpanelContext = createContext<MixpanelContextValue>(initialState)
